<template>
  <div>
    <div v-if="Lib.checkPower('beauty-3-ckgkyyjl2',2)" style="margin-top: 15px;">
      <el-table v-loading="loading" :data="tableData" tooltip-effect="light">
        <el-table-column label="预约日期" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.timeDate?scope.row.timeDate.slice(0,10) : '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="预约时间段" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.timeDate?scope.row.timeDate.slice(10,22) : '--' }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="orderCode" label="订单号" :show-overflow-tooltip="true"></el-table-column> -->
        <el-table-column :label="'预约'+Lib.collectively()" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.technicianName || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="预约项目" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.orderContent?scope.row.orderContent[0].name : '--' }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="预约备注" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.remark || '--' }}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="预约状态">
          <template slot-scope="scope">
            <span :class="(scope.row.bookStatus == 0 || scope.row.bookStatus == 1 || scope.row.bookStatus == 3 || scope.row.bookStatus == 4 || scope.row.bookStatus == 5) ? 'bespeakStatus_2' : scope.row.bookStatus == 2 ? 'bespeakStatus_3' : 'bespeakStatus_4'">{{ Lib.getBespeakVal(scope.row.bookStatus,1) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <yz-btn type="primary" @click="bespeakDetails(scope.row.orderId)">详情</yz-btn>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="tableData.length > 0" class="blockThree">
        <el-pagination background :current-page.sync="pageNum" :page-size="10" layout="prev, pager, next, jumper" :total="rowCount" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
      </div>
    </div>
    <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>

    <el-dialog class="yyDetails" title="预约详情" :visible.sync="detailsVisible" width="560px" :append-to-body="true">
      <div class="yyTop">
        <i class="iconfont" :style="(detailsInfo.status == 0 || detailsInfo.status == 1 || detailsInfo.status == 3 || detailsInfo.status == 4 || detailsInfo.status == 2) ? 'color: #67C23A;' : 'color: #C4C0C0'">{{ (detailsInfo.status == 0 || detailsInfo.status == 1 || detailsInfo.status == 3 || detailsInfo.status == 4) ? '&#xe65e;' : ( detailsInfo.status == 2) ? '&#xe767;' : '&#xe65f;' }}</i>
        <span>{{ (detailsInfo.status == 0 || detailsInfo.status == 1 || detailsInfo.status == 3 || detailsInfo.status == 4) ? '已预约' : ( detailsInfo.status == 2) ? '已完成' : '已取消' }}</span>
        <samp :style="(detailsInfo.status == 0 || detailsInfo.status == 1 || detailsInfo.status == 3 || detailsInfo.status == 4) ? 'color: #FA5555;' : 'color: #999;'">{{ detailsInfo.status == 0 ? '待服务' : detailsInfo.status == 1 ? '服务中' : detailsInfo.status == 3 ? '预约超时' : detailsInfo.status == 4 ? '待确认' : detailsInfo.status == -1 ? '商家取消' : detailsInfo.status == -2 ? '预约过期' : detailsInfo.status == -3 ? '用户取消' : detailsInfo.status == -4 ? '商家拒绝' : '' }}</samp>
      </div>
      <div class="yyInfoTitle">
        <span class="sl"></span>
        <span class="sm">预约信息</span>
      </div>
      <div class="yyInfo">
        <p>
          <span>姓名：</span>
          <samp>{{ detailsInfo.memberName }}</samp>
        </p>
        <p>
          <span>联系电话：</span>
          <samp>{{ detailsInfo.phone }}</samp>
        </p>
        <p>
          <span>预约时间：</span>
          <samp>{{ detailsInfo.bookDateTime }}</samp>
        </p>
        <p>
          <span>预约项目：</span>
          <samp>{{ detailsInfo.bookItemName }}</samp>
        </p>
        <p>
          <span>预约{{ Lib.collectively() }}：</span>
          <samp>{{ detailsInfo.bookTechnicianName }}</samp>
        </p>
        <p>
          <span>服务时长：</span>
          <samp>{{ detailsInfo.serviceTime }}分钟</samp>
        </p>
        <p>
          <span>备注：</span>
          <samp>{{ detailsInfo.remark || '--' }}</samp>
        </p>
      </div>
      <div class="yyInfoTitle">
        <span class="sl"></span>
        <span class="sm">其他信息：</span>
      </div>
      <div class="yyInfo">
        <p>
          <span>下单时间：</span>
          <samp>{{ detailsInfo.orderTime }}</samp>
        </p>
        <p>
          <span>来源：</span>
          <samp>{{ detailsInfo.orderSource }}</samp>
        </p>
        <p>
          <span>操作人：</span>
          <samp>{{ detailsInfo.dutyName }}</samp>
        </p>
        <h5 v-if="detailsInfo.orderCode">
          <span>订单号码：</span>
          <samp>{{ detailsInfo.orderCode }}</samp>
          <i class="el-icon-arrow-right" @click="lookOrder(detailsInfo)"></i>
          <label @click="lookOrder(detailsInfo)">查看订单</label>
        </h5>
      </div>
      <div v-if="(detailsInfo.status == -1 || detailsInfo.status == -2 || detailsInfo.status == -3 || detailsInfo.status == -4)" class="yyInfoTitle">
        <span class="sl"></span>
        <span class="sm">取消信息：</span>
      </div>
      <div v-if="(detailsInfo.status == -1 || detailsInfo.status == -2 || detailsInfo.status == -3 || detailsInfo.status == -4)" class="yyInfo">
        <p>
          <span>取消时间：</span>
          <samp>{{ detailsInfo.cancelTime }}</samp>
        </p>
        <p>
          <span>取消原因：</span>
          <samp>{{ detailsInfo.cancelCase }}</samp>
        </p>
      </div>
      <div class="yyFoot">
        <div v-if="detailsInfo.status == 0 || detailsInfo.status == 3">
          <el-button type="primary" @click="handleCommand({name: '开单',item: {bookOrderId: detailsInfo.orderId}})">开单</el-button>
          <el-button type="primary" @click="handleCommand({name: '修改',item: {bookOrderId: detailsInfo.orderId, technicianName: detailsInfo.bookTechnicianName == '到店安排' ? '' : detailsInfo.bookTechnicianName}})">修改</el-button>
          <el-button type="primary" @click="handleCommand({name: '取消',item: {bookOrderId: detailsInfo.orderId}})">取消</el-button>
        </div>
        <div v-else-if="detailsInfo.status == 4">
          <el-button type="primary" @click="handleCommand({name: '确认',item: {bookOrderId: detailsInfo.orderId}})">确认</el-button>
          <el-button type="primary" @click="handleCommand({name: '拒绝',item: {bookOrderId: detailsInfo.orderId}})">拒绝</el-button>
        </div>
        <div v-else-if="detailsInfo.status == 1">
          <el-button type="primary" @click="handleCommand({name: '结算',item: {orderId: detailsInfo.orderId}})">结算</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="dialogVisible" width="560px" :append-to-body="true">
      <span v-show="diaStatus === 2">确定要取消这条预约吗？</span>
      <span v-show="diaStatus === 0">确认要拒绝这条预约订单吗？</span>
      <p v-if="cancelStatus == 0">已超过预约可退定金时间，若顾客已支付定金/使用了划扣次数，取消订单后，定金/划扣次数将<samp class="themeFC">不会</samp>退回顾客</p>
      <p v-if="cancelStatus == 1">若顾客已支付定金/使用了划扣次数，{{ diaStatus == 2 ? '取消' : '拒绝' }}订单后，定金/划扣次数将退回顾客</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="comfirmCancelBespeak">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getBookOrderList, getBookOrderDetail, getBookCancelMsg, getSureOrFalse, getBookFailures
} from '../api';

export default {
  data() {
    return {
      phone: '', // 顾客手机
      tableData: [], // 预约列表信息
      pageNum: 1, // 列表页码
      rowCount: 1, // 列表总数
      // 5.7
      loading: true,
      // 6.8
      detailsVisible: false,
      detailsInfo: {},
      // 6.81
      dialogVisible: false, // 取消预约弹出窗口
      diaStatus: 3, // 弹出窗口文案提示状态
      chooseId: '', // 取消预约的ID
      cancelStatus: 1, // 取消预约退不退定金
    };
  },
  activated() {
    this.phone = window.sessionStorage.customerPhone;
    this.getBookOrderList(1);
  },
  methods: {
    handleCommand(val) {
      if (val.name == '开单') {
        if (this.Lib.checkPower('beauty-2-yykd') == false) return;
        this.openBill(val.item.bookOrderId);
      } else if (val.name == '修改') {
        if (this.Lib.checkPower('beauty-2-xgyy') == false) return;
        this.editBespeak(val.item.bookOrderId, val.item.technicianName);
      } else if (val.name == '结算') {
        if (this.Lib.checkPower('beauty-2-yyjs') == false) return;
        this.settlementOrder(val.item.orderId);
      } else if (val.name == '确认') {
        if (this.Lib.checkPower('beauty-2-yyxxqr') == false) return;
        this.cancelBespeak(val.item.bookOrderId, 1);
      } else if (val.name == '拒绝') {
        if (this.Lib.checkPower('beauty-2-yyxxqr') == false) return;
        this.cancelBespeak(val.item.bookOrderId, 0);
      } else {
        if (this.Lib.checkPower('beauty-2-qxyy') == false) return;
        this.cancelBespeak(val.item.bookOrderId, 2);
      }
    },
    // 待确认状态修改  1是确认  0是拒绝
    isConfirm() {
      const data = {
        orderId: this.chooseId,
        type: this.diaStatus
      };
      getSureOrFalse(data).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: this.diaStatus == 1 ? '确认成功' : '拒绝成功',
            type: 'success'
          });
          this.dialogVisible = false;
          this.getBookOrderList(1);
        } else {
          this.$message(res.msg);
        }
      });
    },
    // 开单
    openBill(id) {
      window.sessionStorage.editOrderId = '';
      window.sessionStorage.bookOrderId = id;
      this.$router.push({
        name: 'stage-serviceBilling'
      });
    },
    // 修改预约
    editBespeak(id, source) {
      window.sessionStorage.bespeakId = id;
      if (source) {
        this.$router.push({
          name: 'stage-bespeakTechnician'
        });
      } else {
        this.$router.push({
          name: 'stage-bespeakService'
        });
      }
    },
    // 结算
    settlementOrder(id) {
      window.sessionStorage.settlementOrderId = id;
      this.$router.push({
        name: 'stage-orderSettlement',
      });
    },
    // 取消预约
    cancelBespeak(id, val) {
      if (val === 2) {
        getBookCancelMsg({ id }).then((res) => {
          if (res.code == 0) {
            this.chooseId = id;
            this.cancelStatus = res.data ? res.data.cancelStatus ? 1 : 0 : 0;
            this.diaStatus = val;
            this.dialogVisible = true;
          } else {
            console.log(res);
          }
        });
      } else if (val === 0) {
        this.chooseId = id;
        this.diaStatus = val;
        this.cancelStatus = 1;
        this.dialogVisible = true;
      } else {
        this.chooseId = id;
        this.diaStatus = val;
        this.cancelStatus = 1;
        this.isConfirm();
      }
    },
    // 确定取消预约
    comfirmCancelBespeak() {
      if (this.diaStatus === 2) {
        const data = {
          id: this.chooseId
        };
        getBookFailures(data).then((res) => {
          if (res.code == 0) {
            this.$message({ message: '取消成功', type: 'success' });
            this.dialogVisible = false;
            this.detailsVisible = false;
            this.getBookOrderList(1);
          } else {
            this.$message(res.msg);
          }
        });
      } else {
        this.isConfirm();
      }
    },
    getBookOrderList(val) {
      this.loading = true;
      this.pageNum = val;
      const data = {
        startDate: '',
        endDate: '',
        keyWord: this.phone,
        pageNum: this.pageNum,
        type: null
      };
      getBookOrderList(data).then((res) => {
        this.tableData = res.data.records;
        this.rowCount = res.data.total;
        this.pageSize = res.data.size;
        this.loading = false;
      });
    },
    handleSizeChange(val) {
      this.getBookOrderList(val);
    },
    handleCurrentChange(val) {
      this.getBookOrderList(val);
    },
    // 子父组件赋值
    newGetListData() {
      // this.getListData();
      this.$emit('getDelStatus', true);
    },
    // 预约详情
    bespeakDetails(id) {
      if (this.Lib.checkPower('beauty-2-ckyy3') == false) return;
      this.detailsVisible = true;
      getBookOrderDetail({ orderId: id }).then((res) => {
        if (res.code == 0) {
          this.detailsInfo = res.data;
        } else {
          console.log(res);
        }
      });
    },
    // 查看详情
    lookOrder(v) {
      window.sessionStorage.orderData = window.JSON.stringify(v);
      this.$router.push({
        name: 'stage-orderDeatilsData',
        params: {
          orderId: v.orderId,
          orderType: v.orderType
        }
      });
    },
  }
};
</script>

<style lang="less" scoped>
.bespeakStatus_1 {
  background-color: #fff8d7;
  border-radius: 4px;
  font-size: 12px;
  padding: 8px 10px;
  color: #e0b900;
}
.bespeakStatus_2 {
  background-color: #ffe9ee;
  border-radius: 4px;
  font-size: 12px;
  padding: 8px 10px;
  color: #fa5555;
}
.bespeakStatus_3 {
  background-color: #e9f9df;
  border-radius: 4px;
  font-size: 12px;
  padding: 8px 10px;
  color: #67c23a;
}
.bespeakStatus_4 {
  background-color: #f5f5f5;
  border-radius: 4px;
  font-size: 12px;
  padding: 8px 10px;
  color: #606266;
}
.yyTop {
  background-color: #F5F7FA;
  height: 57px;
  line-height: 57px;
  padding: 0 20px;
  i {
    font-weight: 100;
    position: relative;
    top: 2px;
    font-size: 20px;
    font-weight: bold;
  }
  span {
    font-size: 18px;
    font-weight: bold;
    padding-left: 5px;
  }
  samp {
    font-size: 14px;
    color: #FA5555;
    float: right;
  }
}
.yyInfoTitle {
  padding: 20px 20px 0 20px;
  .sl {
    float: left;
    width: 5px;
    height: 15px;
    background-color: #409EFF;
    border-radius: 4px;
    position: relative;
    top: 2px;
    margin-right: 5px;
  }
  .sm {
    font-size: 14px;
    color: #333;
    font-weight: bold;
  }
}
.yyInfo {
  display: table;
  p {
    display: flex;
    padding-top: 20px;
    line-height: 16px;
    font-size: 14px;
    span {
      width: 90px;
      float: left;
      text-align: right;
      color: #666;
    }
    samp {
      flex: 1;
      padding-right: 20px;
      color: #000;
    }
  }
  h5 {
    width: 560px;
    padding-top: 20px;
    line-height: 16px;
    font-size: 14px;
    span {
      width: 90px;
      float: left;
      text-align: right;
      color: #666;
    }
    samp {
      color: #000;
    }
    label {
      cursor: pointer;
      float: right;
      color: #409EFF;
    }
    i {
      cursor: pointer;
      float: right;
      color: #409EFF;
      padding: 0 20px 0 5px;
      position: relative;
      top: 1px;
    }
  }
}
.yyFoot {
  padding: 20px;
  float: right;
}
</style>

<style>
.yyDetails .el-dialog .el-dialog__body {
  padding: 0;
}
</style>
